export const hasFilledText = (value: any): boolean => {
  if (!value) {
    return false
  }

  if (Array.isArray(value)) {
    return value.some(hasFilledText)
  }

  return Boolean(value.text?.trim()) || hasFilledText(value.children)
}
